module.exports = __webpack_public_path__ + "workout.png?efd2aa663bb1a331ee8549aa330d0ea5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workout.png
// module id = 39
// module chunks = 0